module.exports = __webpack_public_path__ + "static/media/plan_icon.6a9de9f7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/plan_icon.svg
// module id = 62
// module chunks = 0